import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { take } from 'rxjs';
import { ForgotPasswordFormComponent } from './forgot-password-form/forgot-password-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';

@Injectable({ providedIn: 'root' })
export class AuthModalsService {
  constructor(private modal: NzModalService) {}

  login(returnUrl?: string) {
    const modal = this.modal.create({
      nzContent: LoginFormComponent,
      nzData: {
        returnUrl,
      },
      nzTitle: $localize`Sign In`,
      nzFooter: null,
      nzMaskClosable: false,
      nzCloseOnNavigation: true,
    });

    modal.afterClose.pipe(take(1)).subscribe((res) => {
      const { register, resetPassword } = res || {};
      if (register) this.register(returnUrl);
      else if (resetPassword) this.resetPassword(returnUrl);
    });
  }

  register(returnUrl?: string) {
    const modal = this.modal.create({
      nzContent: RegistrationFormComponent,
      nzData: {
        returnUrl,
      },
      nzTitle: $localize`Register as a student`,
      nzFooter: null,
      nzMaskClosable: false,
      nzCloseOnNavigation: true,
      nzWidth: '700px',
    });
    modal.afterClose.pipe(take(1)).subscribe((res) => {
      const { signIn } = res || {};
      if (signIn) this.login(returnUrl);
    });
  }

  resetPassword(returnUrl?: string) {
    const modal = this.modal.create({
      nzContent: ForgotPasswordFormComponent,
      nzData: {
        returnUrl,
      },
      nzTitle: $localize`Forgot Password`,
      nzFooter: null,
      nzMaskClosable: false,
      nzCloseOnNavigation: true,
      // nzWidth: '700px',
    });
    modal.afterClose.pipe(take(1)).subscribe((res) => {
      const { signIn } = res || {};
      if (signIn) this.login(returnUrl);
    });
  }
}
